import styled from 'styled-components';
import { colors } from '~/styles/remoteControlColors';

export const SatisfactionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 32px;
  margin-bottom: -40px;
`;

export const SatisfactionDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  h2, p {
    font-weight: 500;
    letter-spacing: 0%;
  }

  h2 {
    font-size: 16px;
    line-height: 100%;
    color: ${colors.Grey500};
  }

  p {
    font-size: 12px;
    line-height: 180%;
    color: ${colors.Grey400};
  }
`;
